/**
 * Oceňovací zpráva a srovnávací vzorek.
 *
 * Vzorek a zpráva jsou dvě volání schválně. Dohledání konkurentů
 * v rejstříku trvá minuty, takže se klientovi nejdřív ukáže, co se našlo
 * a kdo se vyřadil, a teprve pak se tiskne.
 */
import { authHeaders } from '../lib/apiFetch';
import { buildValuationRequest } from './valuationCalculator';
import { podkladyNavrhu } from './rozbor';

const API_BASE = process.env.REACT_APP_API_BASE || '';

function telo(wizardState, extra = {}) {
  const c = wizardState.company || {};
  return {
    valuation: buildValuationRequest(wizardState),
    ico: c.ico || '',
    nazev: c.company_name || '',
    rok: wizardState.rok || 0,
    // Zaměření z číselníku. Bez něj backend spadne zpět na segment, což
    // u barefoot obuvi znamená hledat mezi módními značkami obecně.
    obor_cesta: wizardState.obor_cesta || [],
    obor_vlastni: wizardState.obor_vlastni || '',
    valuation_id: wizardState.savedValuationId || null,
    // Tentýž návrh jako na obrazovce: přečtená závěrka a úpravy zisku.
    ...podkladyNavrhu(wizardState),
    ...extra,
  };
}

/** Najde srovnatelné firmy v rejstříku. Trvá desítky sekund až minuty. */
export async function najdiVzorek(wizardState) {
  const res = await fetch(`${API_BASE}/api/vzorek`, {
    method: 'POST',
    headers: await authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(telo(wizardState)),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.detail || `Vzorek se nepodařilo sestavit (${res.status})`);
  }
  return res.json();
}

/** Vytiskne zprávu a stáhne ji jako PDF. */
export async function stahniZpravu(wizardState, vzorekIco = []) {
  const res = await fetch(`${API_BASE}/api/zprava`, {
    method: 'POST',
    headers: await authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(telo(wizardState, { vzorek_ico: vzorekIco })),
  });
  if (!res.ok) {
    const e = await res.json().catch(() => ({}));
    throw new Error(e.detail || `Zprávu se nepodařilo vytisknout (${res.status})`);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `Oceneni_${(wizardState.company?.company_name || 'spolecnost')
    .replace(/\s+/g, '_').slice(0, 40)}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Uvolnit až po kliknutí, jinak prohlížeč nestihne stahování zahájit.
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
